"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
const camelize_1 = __importDefault(require("camelize"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_select_1 = __importDefault(require("react-select"));
const components_1 = require("components");
const config_1 = require("config");
const consumer_api_1 = require("consumer-api");
const consumer_api_custom_1 = require("consumer-api-custom");
const inline_colors_1 = require("inline-colors");
const utils_1 = require("utils");
const ESign = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const { receiptIdEncoded } = (0, react_router_dom_1.useParams)();
    const [showSignField, setShowSignField] = (0, react_1.useState)(false);
    const [signed, setSigned] = (0, react_1.useState)(false);
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const [procedureDateInput, setProcedureDateInput] = (0, react_1.useState)('');
    const [ssnLast4, setSsnLast4] = (0, react_1.useState)('');
    const [signatureText, setSignatureText] = (0, react_1.useState)('');
    const [signConsumerReceipt] = (0, consumer_api_1.usePatchConsumerV2ReceiptsReceiptUuidSignMutation)();
    const [getReceipt, { data: receiptInfo, error, isFetching: isFetchingReceiptInfo },] = (0, consumer_api_1.useLazyGetConsumerV2ReceiptsReceiptUuidQuery)();
    const [getReceiptPDF, { isFetching: isFetchingReceiptPDF }] = (0, consumer_api_custom_1.useLazyGetConsumerV2ReceiptsReceiptUuidPDFQuery)();
    const adjustedReceiptIdEncoded = receiptIdEncoded.includes('%3D')
        ? receiptIdEncoded.substring(0, receiptIdEncoded.indexOf('%3D'))
        : receiptIdEncoded;
    const receiptInfoDecoded = (0, camelize_1.default)(JSON.parse(atob(adjustedReceiptIdEncoded)));
    const isMobile = window.matchMedia('(pointer: coarse)').matches;
    (0, react_1.useEffect)(() => {
        //@ts-expect-error
        getReceipt({ receiptUuid: receiptInfoDecoded.receiptUuid });
    }, []);
    if (!receiptInfo && !error) {
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, {});
    }
    else if (error) {
        return (0, jsx_runtime_1.jsx)("div", { className: "esign-container" });
    }
    else if (receiptInfo &&
        receiptInfo.signedAt &&
        !isMobile &&
        !isFetchingReceiptPDF) {
        //@ts-expect-error
        getReceiptPDF({ receiptUuid: receiptInfoDecoded.receiptUuid })
            .then((response) => {
            if (response.data && response.data.pdfWindowUrl) {
                (0, utils_1.windowOpenAndPrint)(response.data.pdfWindowUrl, true);
            }
        })
            .catch((e) => {
            const errMsg = 'PDF download and print failed';
            (0, utils_1.reportError)('flashError', {
                componentName: 'ESign',
                funcName: 'getReceiptPDF',
                errType: 'pdf',
                errURL: window.location.pathname,
                errMsg: errMsg,
            }, e);
        });
    }
    const receiptInfoFix = receiptInfo;
    const { transaction } = receiptInfoFix;
    const { account, consumerCreditInstrument, location, amount, authCode, referenceId, plan, accountMemberId, status, } = transaction;
    const accountOwner = account.accountMembers.find((member) => member.role === 'owner');
    if (status === 'voided' || status === 'canceled') {
        history.push({
            pathname: (0, config_1.makeCreditPortalPath)('/receipt/', receiptInfoDecoded.receiptUuid, `/transaction-${status}`),
            state: {
                from: '/receipt',
            },
        });
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    let authBuyer;
    if (account.accountMembers.length > 1) {
        const authBuyers = account.accountMembers.filter((member) => member.role === 'authorized_buyer');
        authBuyer = authBuyers.find((buyer) => buyer.accountMemberId === accountMemberId);
    }
    const paymentDetails = {
        alphaeonAccountNumber: consumerCreditInstrument.lenderAccountIdentifier,
        creditLimit: consumerCreditInstrument.creditLimit,
        name: {
            firstName: accountOwner.firstName,
            lastName: accountOwner.lastName,
        },
        availableCreditLimit: consumerCreditInstrument.creditAvailable,
        ssn: accountOwner.ssnLastFour,
        buyer: authBuyer
            ? { firstName: authBuyer.firstName, lastName: authBuyer.lastName }
            : null,
    };
    const placeholderText = 'Click here to sign';
    const selectOptions = [
        { value: 'today', label: 'Today/already happened' },
        { value: 'withinNextThirtyDays', label: 'Within the next 30 days' },
        {
            value: 'notScheduledOrOver30Days',
            label: 'Not scheduled or more than 30 days from now',
        },
    ];
    const handleSuccess = () => {
        history.push({
            pathname: (0, config_1.makeCreditPortalPath)('/receipt/', receiptInfoDecoded.receiptUuid, '/success'),
            state: {
                from: '/receipt',
            },
        });
    };
    const handleClick = () => {
        setShowSignField(true);
    };
    const handleOpenPDFMobile = () => {
        //@ts-expect-error
        getReceiptPDF({ receiptUuid: receiptInfoDecoded.receiptUuid })
            .then((response) => {
            if (response.data && response.data.pdfWindowUrl) {
                (0, utils_1.windowOpenAndPrint)(response.data.pdfWindowUrl, true, false);
            }
        })
            .catch((e) => {
            const errMsg = 'PDF download and print failed';
            (0, utils_1.reportError)('flashError', {
                componentName: 'ESign',
                funcName: 'getReceiptPDF',
                errType: 'pdf',
                errURL: window.location.pathname,
                errMsg: errMsg,
            }, e);
        });
    };
    const handleSubmit = async () => {
        setSubmitting(true);
        const receiptUuid = receiptInfoDecoded.receiptUuid;
        const currentDate = new Date();
        const procedureDateMap = {
            today: (0, utils_1.formatISODate)(currentDate),
            withinNextThirtyDays: (0, utils_1.formatISODate)(new Date(currentDate.getTime() + 2592000000)), //adding 30 days in ms
            notScheduledOrOver30Days: undefined,
        };
        const signReceiptData = {
            receiptUuid: receiptUuid,
            body: {
                ssnLastFour: ssnLast4,
                procedureDate: procedureDateMap[procedureDateInput],
            },
        };
        //@ts-expect-error
        signConsumerReceipt(signReceiptData).then((res) => {
            if ('data' in res) {
                handleSuccess();
            }
            else {
                (0, utils_1.reportError)('flashError', {
                    componentName: 'ESign',
                    funcName: 'signConsumerReceipt',
                    errType: 'receipt',
                    errURL: window.location.pathname,
                    errMsg: 'Error signing receipt',
                });
                setSubmitting(false);
            }
        });
    };
    const handleSign = () => {
        setSigned(true);
        setSignatureText(`${accountOwner.firstName} ${accountOwner.lastName}`);
    };
    const handleProcedureDateInput = (newValue) => {
        if (newValue) {
            setProcedureDateInput(newValue.value);
        }
    };
    const handleLast4 = (e) => {
        if (/^[0-9]*$/.test(e.target.value) && e.target.value.length <= 4) {
            setSsnLast4(e.target.value);
        }
    };
    if (!isFetchingReceiptInfo &&
        !isFetchingReceiptPDF &&
        isMobile &&
        receiptInfoFix?.signedAt) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "esign-container", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", className: "button-warn", onClick: handleOpenPDFMobile, submitting: isFetchingReceiptPDF, children: "Open Receipt" }) }));
    }
    if (isFetchingReceiptInfo ||
        isFetchingReceiptPDF ||
        receiptInfoFix?.signedAt) {
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, {});
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "esign-container", children: [(0, jsx_runtime_1.jsx)("h1", { children: " Patient Receipt" }), (0, jsx_runtime_1.jsx)("div", { className: "account-summary summary refund-complete", children: (0, jsx_runtime_1.jsx)(components_1.ReceiptAccountInfo, { buyer: authBuyer, paymentDetails: paymentDetails, currentLocation: location, name: account.accountMembers[0], alphaeonAccountNumber: consumerCreditInstrument.lenderAccountIdentifier, availableCreditLimit: consumerCreditInstrument.creditAvailable, creditLimit: consumerCreditInstrument.creditLimit, amount: amount, authorizationCode: authCode, referenceId: referenceId }) }), (0, jsx_runtime_1.jsx)("div", { className: "receipt-display-container", children: (0, jsx_runtime_1.jsx)(components_1.ReceiptDisplay, { name: {
                        firstName: accountOwner.firstName,
                        lastName: accountOwner.lastName,
                    }, currentLocation: location, selectedPlanName: plan.name, authorizationCode: authCode, alphaeonAccountNumber: consumerCreditInstrument.lenderAccountIdentifier, terms: plan.terms, amount: amount, isContractSignature: false }) }), !receiptInfoFix?.signedAt ? ((0, jsx_runtime_1.jsxs)("div", { className: "esign-input-fields", children: [(0, jsx_runtime_1.jsxs)("div", { className: "row", children: [(0, jsx_runtime_1.jsxs)("div", { className: "ssn-input-container", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "ssnInput", children: "SSN/ITIN # (Last 4 digits)" }), (0, jsx_runtime_1.jsx)("input", { type: "tel", id: "ssnInput", name: "ssnInput", value: ssnLast4, onChange: handleLast4 })] }), (0, jsx_runtime_1.jsxs)("div", { className: "procedure-date-input-container", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "procedureDateInput", children: "Procedure Date" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { styles: {
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                border: 'none',
                                                borderRadius: '0',
                                                borderBottom: `1px solid ${inline_colors_1.INLINE_COLORS.blackBase}`,
                                                margin: 0,
                                                padding: 0,
                                            }),
                                            container: (baseStyles) => ({
                                                ...baseStyles,
                                                marginTop: '7px',
                                            }),
                                            singleValue: (baseStyles) => ({
                                                ...baseStyles,
                                                color: '#00000e',
                                            }),
                                            menu: (baseStyles) => ({
                                                ...baseStyles,
                                                borderRadius: 0,
                                            }),
                                            indicatorSeparator: (baseStyles) => ({
                                                ...baseStyles,
                                                display: 'none',
                                            }),
                                        }, options: selectOptions, onChange: handleProcedureDateInput, placeholder: "Select Date", value: selectOptions.filter(function (option) {
                                            return option.value === procedureDateInput;
                                        }) })] })] }), showSignField ? ((0, jsx_runtime_1.jsxs)("div", { className: "sign-field", children: [(0, jsx_runtime_1.jsxs)("div", { className: "signature", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "signature-container", children: "Sign Here" }), (0, jsx_runtime_1.jsxs)("div", { id: "signature-container", className: `text-container ${signatureText ? '' : 'pointer'}`, onClick: handleSign, role: "button", tabIndex: 0, onKeyDown: (e) => {
                                            if (e.key === 'Enter') {
                                                handleSign();
                                            }
                                        }, children: [(0, jsx_runtime_1.jsx)("div", {}), signatureText ? ((0, jsx_runtime_1.jsx)("h5", { className: "signature-text", children: signatureText })) : ((0, jsx_runtime_1.jsx)("h5", { className: "placeholder-text", children: placeholderText })), (0, jsx_runtime_1.jsx)(Edit_1.default, { fontSize: "small", className: "edit-signature-icon" })] })] }), (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", className: "button-warn", onClick: handleSubmit, submitting: submitting, pristine: !signed || !procedureDateInput || ssnLast4.length < 4, children: "SUBMIT" })] })) : ((0, jsx_runtime_1.jsx)("div", { className: "sign-and-submit-container", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", onClick: handleClick, className: "button-warn", pristine: !procedureDateInput || ssnLast4.length < 4, children: "CLICK TO SIGN & SUBMIT" }) }))] })) : ((0, jsx_runtime_1.jsx)("div", { className: "esign-input-fields" }))] }));
};
exports.default = ESign;
